import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrTimesheetApprovalsPage } from './klmr-timesheet-approvals';

@NgModule({
  declarations: [
    KlmrTimesheetApprovalsPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrTimesheetApprovalsPage),
  ],
})
export class KlmrTimesheetApprovalsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-timesheet-approvals/klmr-timesheet-approvals.module.ts